import { Component, Inject, LOCALE_ID } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent {
  title = "Furniture-website";

  constructor(
    private translate: TranslateService,
    @Inject(LOCALE_ID) private locale
  ) {
    this.translate.setDefaultLang(this.locale);
    this.translate.use(this.locale);
    this.changeLayout();
  }

  // Change Direction of Lyout RTL/LTR
  changeLayout() {
    if (this.locale === "ar") {
      document
        .getElementsByTagName("html")[0]
        .setAttribute("lang", this.locale);
      document.getElementsByTagName("body")[0].setAttribute("dir", "rtl");
      document.getElementsByTagName("body")[0].style.textAlign = "right";
    } else {
      document
        .getElementsByTagName("html")[0]
        .setAttribute("lang", this.locale);
      document.getElementsByTagName("body")[0].setAttribute("dir", "ltr");
      document.getElementsByTagName("body")[0].style.textAlign = "left";
    }
  }
}
